import styled from 'styled-components';

export const MerchantCardPageContainer = styled.main`
    .fm-entete {
        margin: 0 0 40px;

        .fm-entete-offre {
            .cashback {
                font-size: 22px;
                line-height: 1.2;

                .value {
                    font-weight: ${props => props.theme.boldWeight};
                    color: ${props => props.theme.partnerCardMainDiscountColor};
                    font-family: ${props => props.theme.fontStackSpecial};
                }

                .small {
                    margin-top: 10px;
                }

                .olieu {
                    font-size: 18px;
                }
            }
        }

        .validation-date {
            margin: 10px 0 0;

            span {
                color: ${props => props.theme.partnerCardValidationDateColor};
            }
        }

        .fm-entete-bt .bt {
            font-weight: ${props => props.theme.boldWeight};
        }
    }

    .noListMarker {
        ul {
            list-style-type: none;
        }
    }

    .fm-mea {
        text-align: center;
        background: ${props => props.theme.merchantCardMeaBackgroundColor};
        margin: 40px 0;
        padding: 10px 0;

        .pointer {
            cursor: pointer;
        }
    }

    .flex-start {
        align-items: flex-start;
    }

    .fm-coupon {
        min-height: 82px;
        height: auto;
        border: 1px solid ${props => props.theme.merchantCardCouponBorderColor};
        margin-bottom: 20px;
        padding: 20px;

        .bt {
            font-size: 14px;
            padding: 14px 0;
            width: 100%;
            font-weight: ${props => props.theme.boldWeight};
            text-align: center;
            cursor: pointer;
        }

        .bt-null-b-jaune {
            cursor: pointer;
            opacity: 1;
        }

        .duree {
            text-align: center;
            font-size: 12px;
        }
    }

    .fm-coupon:not(.co) {
        cursor: pointer;
    }

    .fm-coupon-svg {
        text-align: center;
        width: calc(100% / 12 - 30px - 0.01px);
        flex: 0 0 auto;

        .svg {
            width: 26px;
            height: 26px;
        }
    }
    .fm-coupon-offre {
        .color2 {
            line-height: 1;

            span {
                font-size: 16px;
            }
        }

        .descoffre {
            font-size: 13px;
        }
    }

    hr {
        background: ${props => props.theme.black};
    }

    h3 {
        text-transform: uppercase;
    }

    .meaContainer {
        margin: 10px 0;

        a + a {
            margin-left: 20px;
        }

        p {
            font-size: 14px;
        }
    }

    @media screen and (min-width: ${props => props.theme.medium}) and (max-width: ${props =>
            props.theme.large}) {
        .fm-mea {
            background: none;
        }
        .fm-entete-offre-bt {
            width: calc(100% - 229px - 30px);
            flex: 1 calc(100% - 229px - 30px);
            flex-direction: column;
            align-items: flex-start;
        }
        .fm-entete .fm-entete-bt {
            width: 100%;
            margin: 15px 0 0;
        }
        .fm-entete-offre .color2 {
            line-height: 1.2;
            margin-bottom: 10px;
        }
        .fm-entete .fm-entete-bt .bt {
            margin-left: 0;
        }
        .fm-coupon {
            height: auto;
        }
        .fm-coupon .fm-coupon-bt {
            width: calc(100% / 4 - 30px - 0.01px);
        }
        .fm-coupon .duree {
            font-size: 11px;
        }
    }

    @media screen and (max-width: ${props => props.theme.mobile}) {
        .h1-titre {
            margin: 20px 0 30px;
        }
        .fm-coupon {
            height: auto;
            padding: 20px;
            text-align: center;
            max-width: 280px;
            margin: 0 auto 30px;
        }
        .fm-entete {
            margin: 0 auto 30px;

            .availabilityType {
                margin-top: 10px;
            }
        }
        .fm-entete-offre .cashback {
            display: flex;
            flex-direction: column;
        }
        .fm-entete .fm-entete-offre .color2 {
            font-size: 16px;
            line-height: 1.1;
        }
        .fm-entete .fm-entete-offre .color2 strong {
            font-size: 18px;
        }
        .fm-entete .fm-entete-offre .small {
            margin-top: 5px;
        }
        .fm-entete-bt {
            margin-top: 20px;
        }

        .fm-coupon {
            min-height: 210px;
            height: auto;
            padding: 20px;
        }
        .fm-coupon .color2 {
            margin-bottom: 15px;
        }
        .fm-coupon .bt {
            margin: 20px 0;
        }
        .fm-coupon-offre .color2 span {
            font-size: 18px;
        }
    }
`;

//Added specificity over global class .conteneur
export const HelpContainer = styled.div`
    &.conteneur {
        display: flex;
        margin-top: 0;
        margin-bottom: 60px;
        flex-direction: row;

        @media (max-width: ${props => props.theme.mobile}) {
            flex-direction: column;
            margin-bottom: 0;
        }
    }
`;

export const FaqContainer = styled.div`
    width: 747px;
    border: 3px solid ${props => props.theme.faqContainerColor};
    display: inline-block;
    vertical-align: top;

    .faq-bandeau {
        background: ${props => props.theme.faqContainerColor};
        color: ${props => props.theme.faqContainerTitleColor};
        font-size: 16px;
        text-align: center;
        height: 60px;
        padding: 16px 0;
        font-weight: ${props => props.theme.boldWeight};

        .faq-list-container {
            padding: 0 15px;
        }
    }

    .faq-section {
        padding: 23px 15px 0;
    }

    .faq-section .question-comment-ca-marche-page {
        cursor: pointer;
        position: relative;
        padding-right: 30px;
    }

    @media screen and (min-width: ${props => props.theme.medium}) and (max-width: ${props =>
            props.theme.large}) {
        width: 66%;
    }

    @media screen and (max-width: ${props => props.theme.mobile}) {
        width: 100%;
        border: none;
        border-bottom: 3px solid ${props => props.theme.faqContainerColor};
    }
`;



// WEBPACK FOOTER //
// ./src/components/pages/merchantcard/MerchantCardPageStyle.js